<template>
  <div class="hello">
    <h2>(404) Page NotFound</h2>
    <p>
      <span class="red--text">http://kompetencehuset{{ url }}</span> was not
      found
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: this.$route.path //this.$route.query.page
    };
  },
  created() {
    console.log(this.$route.path);
  }
};
</script>
